import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { TicketsService } from 'src/app/services/tickets-service/tickets.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';

@Component({
  selector: 'app-tickets-tickets-dashboard',
  templateUrl: './tickets-tickets-dashboard.component.html',
  styleUrls: ['./tickets-tickets-dashboard.component.scss']
})
export class TicketsTicketsDashboardComponent implements OnInit, OnDestroy {

  tickets;
  filterKey;
  filterOpts;
  noItemsConfig;
  viewDisposition = 'grid';
  getTicketsSubscription: Subscription;
  searchTicketsSubscription: Subscription;
  filterTicketsSubscription: Subscription;
  toggleTicketsDispositionSubscription: Subscription;

  constructor(private ticketsService: TicketsService,
              private snackbarService: SnackBarService,
              private userStorageService: UserStorageService,
              private cd: ChangeDetectorRef,
              private headerBreadcrumbService: HeaderBreadcrumbService) {
                this.noItemsConfig = this.setNoItemsConfig();
              }

  ngOnInit() {
    this.setBreadcrumb();
    this.getTickets();
    this.ticketsService.refreshTicketsListen().subscribe(
      (res) => {
        this.getTickets();
      }
    );
    this.filterTicketsSubscription = this.ticketsService.filterTicketsListen().subscribe(
      (res) => {
        this.filterOpts = res;
        this.cd.detectChanges();
      }
    );
    this.searchTicketsSubscription = this.ticketsService.searchTicketsListen().subscribe(
      (res) => {
        this.filterKey = res;
      }
    );
    this.toggleTicketsDispositionSubscription = this.ticketsService.toggleTicketsDispositionListen().subscribe(
      (res) => {
        this.viewDisposition = res;
      }
    );
  }

  private getTickets() {
    this.getTicketsSubscription = this.ticketsService.getTicketList().subscribe(
      (res) => {
          this.tickets = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-receipt', 'tickets-page.tickets', '/account', [new BRoute('account-page.account', '/account'), new BRoute('tickets-page.tickets')]));
  }

  private setNoItemsConfig() {
    return {
      description: 'tickets-page.tickets not found',
      action: '',
      lottieConfig: {
        path: 'assets/lottie-animations/empty-list.json',
        renderer: 'canvas',
        autoplay: true,
        loop: true
      }
    };
  }

  ngOnDestroy() {
    if (this.getTicketsSubscription) { this.getTicketsSubscription.unsubscribe(); }
    if (this.searchTicketsSubscription) { this.searchTicketsSubscription.unsubscribe(); }
    if (this.filterTicketsSubscription) { this.filterTicketsSubscription.unsubscribe(); }
    if (this.toggleTicketsDispositionSubscription) { this.toggleTicketsDispositionSubscription.unsubscribe(); }
  }

}
